import { useCallback, useMemo } from 'react'

import { FIELD_VALUE_TYPE } from '@constants'
import { FormRow } from '@types'

import { mapCoreKeysToFormKeys } from '../helpers/mapCoreKeysToFormKeys'
import { ExecuteCommandGetArgs } from '../types'

import { useExecuteCommandMutationWithFixedKey } from './useExecuteCommandMutationWithFixedKey'

// Важно учитывать, что благодаря fixedCacheKey, вызов fetch приведёт к обновлению данных везде, где используется этот хук
export const useFetchObjectDataWithFixedKey = (
  globalId: string,
  typeId?: FIELD_VALUE_TYPE,
  fields?: FormRow[]
) => {
  const fixedCacheKey = `display-form-fetch-object-data-${globalId}`

  const [executeCommand, executeCommandResult] =
    useExecuteCommandMutationWithFixedKey(fixedCacheKey)

  const isInternalIdMode = typeId === FIELD_VALUE_TYPE.OBJ_INTERNAL_ID_LINK

  const fetchObjectData = useCallback(
    (args: ExecuteCommandGetArgs) => {
      return executeCommand({
        method: args.method,
        objectCode: args.objectCode,
        commandCode: args.commandCode,
        params: args.params,
        body: args.body,
        expands: args.expands,
        resource: args.resource,
      })
    },
    [executeCommand]
  )

  const rawObjectData = executeCommandResult.data

  const normalizedObjectData = useMemo(() => {
    if (Array.isArray(rawObjectData)) {
      return rawObjectData[0]
    }

    return rawObjectData
  }, [rawObjectData])

  const mappedObjectData = useMemo(() => {
    return normalizedObjectData && fields?.length
      ? mapCoreKeysToFormKeys(normalizedObjectData, fields)
      : normalizedObjectData
  }, [normalizedObjectData, fields])

  return [
    fetchObjectData,
    {
      ...executeCommandResult,
      data: mappedObjectData,
      isInternalIdMode,
    },
  ] as const
}
